module.exports = __webpack_public_path__ + "img/long-logo.ed35a8b4.svg";